import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * TierLimitWarningModal - Warning modal for tier limit errors
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Callback when modal is closed
 * @param {string} props.message - Error message to display
 */
export function TierLimitWarningModal({ isOpen, onClose, message }) {
    const navigate = useNavigate();

    if (!isOpen) {
        return null;
    }

    const handleUpgrade = () => {
        onClose();
        navigate('/dashboard/settings/membership');
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6">
                <div className="flex items-center mb-4">
                    <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-yellow-100 mr-3">
                        <svg
                            className="w-6 h-6 text-yellow-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            />
                        </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-800">Limit Reached</h3>
                </div>
                <p className="text-gray-600 mb-6 ml-12">{message}</p>
                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-gray-800 transition"
                    >
                        Close
                    </button>
                    <button
                        onClick={handleUpgrade}
                        className="px-4 py-2 rounded bg-primary hover:bg-primary-dark text-white transition"
                    >
                        Upgrade Plan
                    </button>
                </div>
            </div>
        </div>
    );
}

